import React from "react";
import {
  Typography,
  Calendar,
  message,
  Descriptions,
  Badge,
  Row,
  Modal,
  Select,
  DatePicker,
  Radio,
  Button,
  Avatar,
  Popover,
  Menu,
  Tag,
  Icon,
} from "antd";
import moment from "moment";
import axios from "axios";
import { get, isEmpty, sumBy, groupBy } from "lodash";
import "./Styles.less";
import LeadPreview from "../Leads/LeadPreview";

const { MonthPicker } = DatePicker;
const { Option } = Select;
const { Text } = Typography;

class TaskCalendarv2 extends React.Component {
  state = {
    singleLoading: false,
    singleData: {},
    visible: false,
  };

  elipsisTitle = (title, count = 12) => {
    if (title && title.length > count) {
      let r = title.substring(0, count - 1);
      return r + "...";
    }
    return title;
  };

  getAvatar(tender, commercial, double_up) {
    const init = {
      tender: "Tender",
      commercial: "CM",
      double_up: "DU",
    };
    let avatar;
    if (tender && commercial) avatar = "T&C";
    else if (tender) avatar = init.tender;
    else if (commercial) avatar = init.commercial;
    else if (double_up) avatar = init.double_up;
    else avatar = "Task";
    return avatar;
  }

  infoTask(data) {
    Modal.destroyAll();
    Modal.info({
      title: `Task #${data.id}: ${data.title}`,
      width: 700,
      content: (
        <Descriptions>
          <Descriptions.Item label="Due date">
            <Badge>{data.due_date}</Badge>
          </Descriptions.Item>
          <Descriptions.Item label="Lead">
            {get(data.lead, "name") ? (
              <Button
                onClick={() => this.fetchSingle(data.lead.id)}
                icon="container"
                type="dashed"
                className="ant-form-text"
              >
                {get(data.lead, "name")}
              </Button>
            ) : (
              "No Lead"
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Status">{data.status}</Descriptions.Item>
          <Descriptions.Item label="Created on">
            {moment(data.created_on).format("LLL")}
          </Descriptions.Item>
          <Descriptions.Item label="Description">
            {data.description}
          </Descriptions.Item>
        </Descriptions>
      ),
      onOk() {},
    });
  }

  detailCell(c) {
    // const data = []
    // const r = groupBy(d, 'status')
    // for (const i in r) {
    //   if (i === "null")
    //     data.push({ status: 'No status', data: r[i] })
    //   else
    //     data.push({ status: i, data: r[i] })
    // }
    return (
      <Menu
        mode="vertical"
        selectedKeys="[]"
        style={{ maxHeight: `${600}px`, overflowY: "scroll" }}
      >
        {/* {data.map((c, i) => (
          <SubMenu
            key={i}
            title={
              <span className="mr-3">
                <Avatar size="small" className="mr-2">
                  {c.data.length}
                </Avatar>{' '}
                {this.elipsisTitle(c.status)}
              </span>
            }
          >
            <Menu.ItemGroup title={c.name} style={{ maxHeight: `${600}px`, overflowY: 'scroll' }}> */}
        {c.map((val, index) => (
          <Menu.Item key={index} onClick={() => this.infoTask(val)}>
            <Avatar
              className="mr-2"
              shape="square"
              size="small"
              style={{
                backgroundColor: "#00bfff",
              }}
            >
              {this.getAvatar(val.tender, val.commercial, val.double_up)}
            </Avatar>
            <Text type="secondary"> #{val.id}: </Text>
            {val.title} ·{" "}
            <Icon
              title={val.name}
              className={!val.owner && "text-danger"}
              type="user"
              style={{ marginRight: "2px" }}
            />
            {val.lead ? (
              this.elipsisTitle(val.lead.name)
            ) : (
              <font className="text-danger">No lead</font>
            )}
          </Menu.Item>
        ))}
        {/* </Menu.ItemGroup>
          </SubMenu>
        ))} */}
      </Menu>
    );
  }

  dateCellRender = (value) => {
    const { task } = this.props;
    const data = task.filter(
      (e) => e.due_date === moment(value).format("YYYY-MM-DD")
    );
    const __defaultDate = () => {
      return (
        <div className="ant-fullcalendar-date" style={{ borderRadius: "3px" }}>
          <div className="ant-fullcalendar-value">
            {moment(value).format("DD")}
          </div>
          <div
            className="ant-fullcalendar-content"
            style={{ overflowX: "auto" }}
          >
            <div className="mt-1">
              {data &&
                data.map((item, i) => (
                  <div key={i}>
                    <Typography.Text
                      className="one-line"
                      style={{ fontSize: "12px" }}
                      type="secondary"
                      key={i}
                    >
                      <Avatar
                        size={13}
                        style={{
                          backgroundColor: "#0acd00",
                        }}
                      >
                        {item.id}
                      </Avatar>{" "}
                      {`${item.title} · ${this.elipsisTitle(
                        get(item, "lead.name", "No lead"),
                        7
                      )}`}
                    </Typography.Text>
                  </div>
                ))}
            </div>
          </div>
        </div>
      );
    };
    const __filled = () => {
      return (
        <Popover
          placement="right"
          title={
            <div
              style={{
                borderLeft: "3px solid deepskyblue",
                backgroundColor: "#eaeff5",
              }}
            >
              <Typography.Text
                style={{
                  marginRight: "5px",
                  marginLeft: "5px",
                  fontSize: "16px",
                }}
                type="secondary"
                className="mr- 1"
                strong
              >
                Task due at {moment(value).format("DD MMM YYYY")}
              </Typography.Text>
            </div>
            // <Typography.Text type="secondary" strong>
            //   Job due at {moment(value).format('DD MMM YYYY')}
            // </Typography.Text>
          }
          content={this.detailCell(data)}
          // trigger="click"
        >
          {__defaultDate()}
        </Popover>
      );
    };
    return isEmpty(data) ? __defaultDate() : __filled();
  };

  getMonthdata = (value) => {
    const { yjobs } = this.props;
    const date = moment(value).format("MM-YYYY");
    const job = get(yjobs, "jobs", []).find(
      (e) => moment(e.instructed_finish_month).format("MM-YYYY") === date
    );
    return job;
  };

  monthRender = (e) => {
    console.log(e);
    const w = this.getMonthdata(e);
    if (get(w, "job_queues")) {
      return (
        <div>
          <div
            style={{
              borderLeft: "3px solid rgb(24, 144, 255)",
              backgroundColor: "rgb(217, 236, 253)",
              padding: "8px",
              margin: "12px 0px",
            }}
          >
            Total job: {sumBy(w.job_queues, "total_job")}
          </div>
          {w.job_queues.map((item, i) => (
            <div key={i}>
              <Typography.Text className="one-line" type="secondary">
                <Avatar
                  size={10}
                  style={{
                    backgroundColor: "#0acd00",
                  }}
                />{" "}
                {item.name} · Total job :{" "}
                <Avatar
                  size={17}
                  style={{
                    fontSize: "10px",
                    backgroundColor: "#aa5fff",
                  }}
                >
                  {item.total_job}
                </Avatar>
              </Typography.Text>
            </div>
          ))}
        </div>
      );
    }
    return;
  };

  operation(view, date, onChange, next = true) {
    let r = date;
    if (next) r = moment(date).add(1, "M");
    else r = moment(date).subtract(1, "M");
    // view(r, 'month')
    onChange(r);
    return r;
  }

  disabledDate() {
    return false;
  }

  renderPicker = (type, e) => {
    const [p] = [this.props];
    let content = (
      <div justify="center">
        <Button
          type="default"
          style={{
            borderTopRightRadius: "0px",
            borderBottomRightRadius: "0px",
          }}
          onClick={() =>
            this.operation(p.onChangeview, e.value, e.onChange, false)
          }
        >
          <Icon type="left" />
          Prev
        </Button>
        <MonthPicker
          allowClear={false}
          format="MMM YYYY"
          style={{ marginRight: "0.5rem", marginLeft: "0.5rem" }}
          value={moment(String(e.value))}
          disabledDate={() => this.disabledDate()}
          onChange={(selectedMonth, s) => {
            e.value = selectedMonth;
            // p.onChangeview(e.value)
            e.onChange(selectedMonth);
          }}
        />
        <Button
          style={{
            borderTopLeftRadius: "0px",
            borderBottomLeftRadius: "0px",
            marginRight: "10px",
          }}
          type="default"
          onClick={() => this.operation(p.onChangeview, e.value, e.onChange)}
        >
          Next
          <Icon type="right" />
        </Button>
      </div>
    );
    if (type === "year") {
      const w = e.value.year();
      const res = [];
      for (let i = 1; i < 20; i++) {
        res.push(w - 11 + i);
      }
      content = (
        <Select
          defaultValue={w}
          style={{ width: "150px" }}
          dropdownClassName="same"
          onChange={(r) => {
            e.value = moment(
              `${r}-${moment(new Date()).format("MM")}-${moment(
                new Date()
              ).format("DD")}`
            );
            // p.onChangeview(e.value, 'year')
            e.onChange(e.value);
          }}
          className="mr-2"
        >
          {res.map((i, key) => (
            <Option value={i} key={key}>
              {i}
            </Option>
          ))}
        </Select>
      );
    }
    return content;
  };

  headerRender = (e) => {
    const [p] = [this.props];
    return (
      <Row type="flex" justify="end">
        {this.renderPicker(p.vector, e)}
        <Radio.Group
          onChange={(r) => p.onChangeview(e.value, r.target.value)}
          value={p.vector}
          buttonStyle="solid"
        >
          <Radio.Button value="month">Month</Radio.Button>
          <Radio.Button disabled value="year">
            Year
          </Radio.Button>
        </Radio.Group>
      </Row>
    );
  };

  handleState = (key, value) => {
    let obj = {};
    obj[key] = value;
    this.setState(obj);
  };

  fetchSingle = (leadID) => {
    axios
      .get(process.env.REACT_APP_AXIOS_URL + `/api/leads/${leadID}/`)
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            singleData: res.data,
            singleLoading: false,
            visible: true,
          });
        } else {
          message.error("Something went wrong");
        }
      })
      .catch((error) => {});
  };

  render() {
    const [p] = [this.props];
    const sp = {};
    if (p.vector === "year") sp.onSelect = (e) => p.selectMonth(e);
    return (
      <Row>
        <Calendar
          {...sp}
          mode={p.vector}
          onPanelChange={(l, e) => p.onChangeview(l, e)}
          headerRender={this.headerRender}
          dateFullCellRender={this.dateCellRender}
          monthCellRender={this.monthRender}
        />
        <LeadPreview
          singleData={this.state.singleData}
          singleLoading={this.state.singleLoading}
          visible={this.state.visible}
          handleState={this.handleState}
        />
      </Row>
    );
  }
}

export default TaskCalendarv2;

TaskCalendarv2.defaultProps = {
  jobs: [],
  yjobs: [],
};



// WEBPACK FOOTER //
// ./src/containers/Tasks/TaskCalendarv2.js